<div>
  <div class="logo-wrapper">
    <a [routerLink]="['/pages/first-page']">
      <img class="img-fluid" src="assets/img/logo/logoSafe.jpg" alt="" />
    </a>
    <div class="back-btn" (click)="closeMenu()">
      <i class="fa fa-angle-left"></i>
    </div>
    <div class="toggle-sidebar" (click)="closeMenu()">
      <app-feather-icons [class]="'status_toggle middle sidebar-toggle'" [icons]="'grid'"></app-feather-icons>
    </div>
  </div>
  <div class="logo-icon-wrapper">
    <a [routerLink]="['/pages/first-page']">
      <img class="img-fluid" src="assets/img/logo/logoSafe.jpg" alt="" />
    </a>
  </div>
  <div class="profile-section sidebar-search">
    <div class="profile-wrapper">
<!--      <div class="active-profile">-->
<!--        <img class="img-fluid" src="assets/images/user.png" alt="user" />-->
<!--        <div class="status bg-success"></div>-->
<!--      </div>-->
        <div class="rounded-border">
            <div class="circle-success">
                <p class="txt-primary">{{ userLogged?.nameShort }}</p>
            </div>
        </div>
      <div>
        <h4>{{ userLogged?.name }}</h4>
        <span>{{ userLogged?.description }}</span>
      </div>
    </div>
    <div>
      <app-common-svg-icons [icons]="'profile-setting'"></app-common-svg-icons>
    </div>
  </div>
  <nav class="sidebar-main">
    <div class="left-arrow" id="left-arrow" (click)="scrollToLeft()">
      <app-feather-icons [icons]="'arrow-left'"></app-feather-icons>
    </div>
    <div id="sidebar-menu"
    [ngStyle]="{ 'margin-left': layoutServices.margin + 'px' }">
      <ul class="sidebar-links" id="simple-bar">
        <li class="back-btn">
          <a [routerLink]="['/pages/first-page']">
            <img class="img-fluid" src="assets/images/logo/logo-icon.png" alt="">
          </a>
          <div class="mobile-back text-end">
            <span>Back</span>
            <i class="fa fa-angle-right ps-2" aria-hidden="true"></i>
          </div>
        </li>
        <li class="pin-title sidebar-main-title" [class.show]="pinnedData">
          <div>
            <h6>- Pinned</h6>
          </div>
        </li>
        <ng-container *ngTemplateOutlet="recursiveMenu; context: { $implicit: menuItemsList }"></ng-container>
        <ng-template #recursiveMenu let-menuItemsList>
          @for ( item of menuItemsList; track item) {
          <li [class.pined]="isPined(item.title)" [class.sidebar-main-title]="item.headTitle1"
            [class.sidebar-list]="item.level == 1">
            @if (item.headTitle1) {
            <div>
              <h6>- {{item.headTitle1 | translate}}</h6>
            </div>
            }
            @if (item.level == 1) {
            <i class="fa fa-thumb-tack" (click)="pinned(item.title)"></i>
            }
            @if(item.badgeValue){
            <label class="badge badge-{{item.badgeType}}">{{item.badgeValue}}</label>
            }
            @if (item.type === 'extTabLink') {
            <a href="{{ !item.type ? null : item.path }}">
              {{ item.title | translate }}
            </a>
            }
            @else {
            @if (!item.headTitle1) {
            <a [ngClass]="{ 'sidebar-link sidebar-title' : item.level == 1, 'submenu-title submenu-wrapper' : item.level == 2 , 'active' : item.active && (item.level == 1 || item.level == 2) }"
              routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              [class.link-nav]="!item.children &&  item.level == 1" [routerLink]="item.path"
              (click)="toggleNavActive(item)">
              @if (item.icon && item.level == 1) {
              <app-svg-icons [icons]="item.icon"></app-svg-icons>
              }
              @if (item.level == 1) {
              <span>{{item.title| translate}}</span>
              }
              @else {
              {{item.title | translate}}
              }
              @if (item.children || item.level == 2) {
              <div class="according-menu">
                <i class="fa fa-angle-{{ item.active ? 'down' : 'right' }} pull-right"></i>
              </div>
            }
            </a>
            }
            }
            @if (item.children) {
            <ul [class.sidebar-submenu]="item.level == 1"
              [ngClass]="{'nav-sub-childmenu submenu-content' : item.level == 2}"
              [style.display]=" item.active ? 'block' : 'none'">
              <ng-container *ngTemplateOutlet="recursiveMenu; context: { $implicit: item.children }"></ng-container>
            </ul>
            }
          </li>
          }
        </ng-template>
      </ul>
    </div>
    <div class="right-arrow" id="right-arrow"  (click)="scrollToRight()">
      <app-feather-icons [icons]="'arrow-right'"></app-feather-icons>
    </div>
  </nav>
</div>
